<template>
  <div class="w-full h-full">
    <div class="icon-search__input mt-5px">
      <el-input class="w-full" placeholder="请输入机器人名称" v-model="keyWords" clearable>
        <i slot="append" class="el-icon-search cursor-pointer" @click="getTableList"></i>
      </el-input>
    </div>
    <el-table
      ref="tableRef"
      height="calc(100% - 90px)"
      class="mt-10px"
      :data="tableData"
      highlight-current-row
      row-key="id"
    >
      <el-table-column width="50" :label="`${$t('序号')}`" type="index"></el-table-column>
      <el-table-column :label="`${$t('机器人名称')}`" show-overflow-tooltip prop="robotName">
      </el-table-column>
      <el-table-column :label="`${$t('巡检对象名称')}`" show-overflow-tooltip prop="deviceName">
      </el-table-column>
      <el-table-column :label="`${$t('操作')}`" show-overflow-tooltip width="50">
        <template #default="{ row }">
          <div class="w-15px cursor-pointer text-[#00BCC8]" @click="lookDetail(row)">查看</div>
        </template>
      </el-table-column>
    </el-table>
    <el-pagination
      background
      :total="page.total"
      :current-page.sync="page.pageNo"
      :page-size.sync="page.pageSize"
      class="h-35px mt-5px text-center"
      layout="prev, pager, next"
      @current-change="getTableList()"
      :pager-count="5"
    >
    </el-pagination>
    <RobotDetailDig v-if="showDetailDig" @close="closeDig"></RobotDetailDig>
  </div>
</template>

<script>
import { RobotApi, ViewPointApi } from '@wiz-api/huizhou2'
import { transferSkipCount } from '@/assets/js/TransferPage'

const robotApi = new RobotApi()
const viewPointApi = new ViewPointApi()

const RobotDetailDig = () => {
  return import('./components/RobotDetailDig')
}
export default {
  props: {
    transferProps: {
      type: Object,
      default: () => {
        return {}
      },
    },
    cloudRender: {
      type: Object,
      default: () => {
        return {}
      },
    },
  },
  components: { RobotDetailDig },
  data() {
    return {
      keyWords: '',
      tableData: [],
      page: {
        total: 0,
        pageSize: 15,
        pageNo: 1,
      },
      showDetailDig: false,
    }
  },
  methods: {
    async getTableList() {
      const [err, res] = await robotApi.getRobotViewObjectList({
        keyWord: this.keyWords,
        skipCount: transferSkipCount(this.page.pageNo, this.page.pageSize),
        maxResultCount: this.page.pageSize,
      })
      if (!err) {
        this.tableData = res.items
        this.page.total = res.totalCount
      }
    },
    async lookDetail(row) {
      // this.showDetailDig = true // 暂时屏蔽弹框
      const info = await this.getPointInfo(row.robotKey)
      if (info && info.position) {
        this.drawMarker(info, 'robot-normal')
        if (info.perspective) {
          const perspective = JSON.parse(info.perspective)
          const cameraParams = {
            eye: perspective[0].split(',').map((it) => {
              return Number(it)
            }),
            target: perspective[1].split(',').map((it) => {
              return Number(it)
            }),
            up: perspective[2].split(',').map((it) => {
              return Number(it)
            }),
          }
          await this.cloudRender.Camera.moveCamera('CameraParam', cameraParams)
        }
      }
    },
    // 绘制图标
    async drawMarker(deviceDetail, type) {
      await this.cloudRender.Marker?.destroyAllMarker()
      const backgroundUrl = `data://../apps/markers/inspectionAPicture/${type}.png`
      const pictureOption = {
        id: deviceDetail.id,
        pos: JSON.parse(deviceDetail.position),
        backgroundUrl,
        visible: true,
        nodeOffset: [0, 0],
        imgSize: [41, 59],
        markPosType: 1,
      }
      await this.cloudRender.Marker.createByPicture(pictureOption)
    },
    closeDig() {
      this.showDetailDig = false
    },
    // 获取当前点位信息
    async getPointInfo(id) {
      const [err, res] = await viewPointApi.getViewPointSync({ robotId: id })
      if (!err) {
        return res
      }
      return false
    },
  },
  created() {
    this.getTableList()
  },
  mounted() {},
  async beforeDestroy() {
    await this.cloudRender.Marker?.destroyAllMarker()
  },
}
</script>

<style>
</style>
